import { S3BrowserAccessService } from "../services/S3BrowserAccessService"
import { useCallback, useEffect, useMemo, useState } from "react";
import { awsResources } from "../config/runtimeConfig";

import {
    GetObjectCommand,
    S3,
    _Object,
    PutObjectCommandOutput,
} from "@aws-sdk/client-s3";
import { FileUploader } from "react-drag-drop-files";
import { Button, ListGroup, Spinner } from "react-bootstrap";
import { getSignedUrl } from "@aws-sdk/s3-request-presigner";

export function S3ExamplePage() {

    const s3BrowserAccessService = useMemo(() => new S3BrowserAccessService(), []);
    const [s3Client, setS3Client] = useState<S3 | null>(null);
    const [uploadInProgress, setUploadInProgress] = useState(false);
    const [loadInProgress, setLoadInProgress] = useState(false);
    const [items, setItems] = useState<_Object[]>([]);

    const bucket = awsResources.BackendBucketName;

    const toFilesArray = (files: File | File[] | FileList): File[] => {
        if (files instanceof File) {
            return [files];
        }

        return Array.from(files);
    };
    
    const updateList = useCallback(async () => {
        setLoadInProgress(true);
        const output = await s3Client?.listObjectsV2({ Bucket: bucket });
        setItems(output?.Contents || []);
        setLoadInProgress(false);
    }, [s3Client]);

    useEffect(() => {
        updateList();
    }, [s3Client, updateList]);

    useEffect(() => {
        const init = async function () {
            const s3 = await s3BrowserAccessService.createS3Client();
            setS3Client(s3);
        }

        init().catch(error => console.error(error));

    }, [s3BrowserAccessService]);
    return <>
        <h1>S3 Example {(loadInProgress || uploadInProgress) && <Spinner animation="border" />}</h1>
        <p>Click on the dotted frame below to upload a file, or drag-and-drop files on said frame.</p>
        <FileUploader
        multiple={true}
        handleChange={async (files: File | File[] | FileList) => {
            setUploadInProgress(true);
            let promises: Promise<PutObjectCommandOutput>[] = [];
            const uploadedFiles = toFilesArray(files);
            await Promise.all(uploadedFiles.map(async (file) => {
                const promise = s3Client?.putObject({
                    Bucket: bucket,
                    Key: file.name,
                    Body: new Uint8Array(await file.arrayBuffer()),
                    ContentType: file.type || undefined,
                });
                if (promise)
                    promises.push(promise);
                else 
                    console.error("File " + file.name + " could not be uploaded...");
            }));

            await Promise.all(promises);
            setUploadInProgress(false);
            updateList();
        }}
        name="file"
      />
        <h3>Available Files</h3>
        <ListGroup variant="flush">
            {items.map(function(item, i){
                return <ListGroup.Item key={item.Key}> <Button onClick={async (e) => {
                    e.preventDefault();
                    const command = new GetObjectCommand({ Bucket: bucket, Key: item.Key! });
                    const url = await getSignedUrl(s3Client!, command, { expiresIn: 3 * 60 });
                    window.open(url, '_blank', 'noreferrer');
                  }}>Download</Button> {item.Key} </ListGroup.Item>;
            })}
            {items.length == 0 && (
                <ListGroup.Item>No files uploaded so far...</ListGroup.Item>
            )}
        </ListGroup>
      </>
}
